module.exports = __webpack_public_path__ + "img/vid09.bbd6c16f.jpg";